export { fetchEventSource, EventStreamContentType } from './fetch';
//# sourceMappingURL=index.js.map